import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup} from '@angular/forms';
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})


export class ContactComponent implements OnInit {

  contactForm = new FormGroup({
      to_name: new FormControl(''),
      from_name: new FormControl(''),
      phone: new FormControl(''),
      message: new FormControl('')
  });


  constructor() { }



  ngOnInit() {

  }



  cleanForm() {
    this.contactForm.reset();
  }

  public sendEmail(e: Event) {
    e.preventDefault();
    emailjs.sendForm('service_mt6gqig', 'template_my3rbn7', e.target as HTMLFormElement, 'user_wYOrxGKtHwRpB4OvnNTxi')
          .then((result: EmailJSResponseStatus) => {
            console.log(result.text);

          }, (error) => {
            console.log(error.text);
          });

    this.cleanForm();

        }
}






